import { usePageContext } from '../../../../context.js';
import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { useTaskContext } from '../../context.js';
import { wrapper, container, whitespace, linebreak } from './_task.mark-words.style.js';
import { WordInput } from './input.word.js';
import { jsx } from 'react/jsx-runtime';

function SelectAnswersMarkWords(props) {
  const pageContext = usePageContext();
  const context = useTaskContext();
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    "data-context": context,
    "data-page-context": pageContext,
    children: /*#__PURE__*/jsx("div", {
      className: container,
      children: props.task.content.map((it, index) => {
        switch (it.nodeType) {
          case "selectable-word-input":
            return /*#__PURE__*/jsx(WordInput, {
              node: it,
              taskEntryKey: props.taskEntryKey
            }, index);
          case "mark-words-whitespace":
            return it.as === "space" ? /*#__PURE__*/jsx("span", {
              className: whitespace,
              children: " "
            }, index) : /*#__PURE__*/jsx("span", {
              className: linebreak,
              children: " "
            }, index);
          case "audio":
            return /*#__PURE__*/jsx(CircledAudioPlayer, {
              src: it.src
            }, index);
        }
      })
    })
  });
}

export { SelectAnswersMarkWords };
//# sourceMappingURL=_task.mark-words.js.map
